
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="text-2xl font-bold text-teal-600 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              The Simple MD
            </div>
            <p className="text-gray-600 mb-4">
              Revolutionizing healthcare through virtual primary care and advanced wellness treatments in Miami, Florida.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-teal-600 transition-colors">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-600 transition-colors">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-600 transition-colors">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-600 transition-colors">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 lg:mb-6">Services</h3>
            <ul className="space-y-2 lg:space-y-3">
              <li>
                <Link to="/virtual-primary-care" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Virtual Primary Care
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Hormone Therapy
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Peptide Therapy
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="text-gray-300 hover:text-teal-400 transition-colors">
                  NAD+ Treatment
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Wellness Optimization
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 lg:mb-6">Company</h3>
            <ul className="space-y-2 lg:space-y-3">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-teal-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Careers
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Press
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center text-gray-600">
                <i className="ri-map-pin-line mr-3 text-teal-600"></i>
                <span>123 Biscayne Blvd, Miami, FL 33132</span>
              </div>
              <div className="flex items-center text-gray-600">
                <i className="ri-phone-line mr-3 text-teal-600"></i>
                <span>(305) 555-0123</span>
              </div>
              <div className="flex items-center text-gray-600">
                <i className="ri-mail-line mr-3 text-teal-600"></i>
                <span>info@thesimplemd.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">
            © 2024 The Simple MD. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-500 hover:text-teal-600 text-sm transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
